import { PURGE } from "redux-persist";

const initialState = {
  therapists: [],
  therapistProfile: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "FETCH_THERAPISTS":
      return {
        ...state,
        therapists: [...payload],
      };
    case "CREATE_THERAPIST_PROFILE":
      return {
        ...state,
        therapistProfile: payload,
      };
    case "FETCH_THERAPIST_PROFILE":
      return {
        ...state,
        therapistProfile: payload,
      };
    case PURGE:
      return initialState;
    case "CLEAR_ORGANIZATION_DATA":
      return initialState;
    default:
      return state;
  }
};
